import { BasicTenant, Mutation } from 'graphql/generated/graphqlTypes';

export function mockedChooseProviderData(
  onboardingChooseProvider: BasicTenant
): Pick<Mutation, 'onboardingChooseProvider'> {
  return {
    onboardingChooseProvider
  };
}

export const mockedChooseCognitoPrividerDataForQuery = mockedChooseProviderData({
  __typename: 'BasicTenant',
  tenantId: 'mockedTenantId',
  name: 'mockedTenantName',
  onboardingStep: 'mockedCognitoOnboardingStep'
});

export const mockedChooseEntraPrividerDataForQuery = mockedChooseProviderData({
  __typename: 'BasicTenant',
  tenantId: 'mockedTenantId',
  name: 'mockedTenantName',
  onboardingStep: 'mockedEntraOnboardingStep'
});
